<template>
  <div id="app">
    <div class="title">
      <div class="image">
        <el-image class="icon" :src="url"></el-image>
      </div>
      <div class="navbar">
        <div @click="turnIndex"
            :class="selectId===0||select===0?'select':'tab'"
            @mouseover="choose(0)"
            @mouseleave="clear">首页</div>
        <div @click="turnEinsim" 
            :class="selectId===1||select===1?'select':'tab'"
            @mouseover="choose(1)"
            @mouseleave="clear">艾因小萌班</div>
        <div @click="turnRole" 
            :class="selectId===2||select===2?'select':'tab'"
            @mouseover="choose(2)"
            @mouseleave="clear">角色</div>
        <div @click="turnCall" 
            :class="selectId===3||select===3?'select':'tab'"
            @mouseover="choose(3)"
            @mouseleave="clear">联系我们</div>
      </div>
      <div class="login" v-if="!this.$store.state.isLogin">
        <div @click="dialogVisible=true" class="loginBtn">登录</div>
            <Login v-if="dialogVisible" page="index"></Login>
      
      </div>
      <div class="login" v-else>
        <el-dropdown  @command="handleCommand">
        <img class="head" :src="this.$store.state.head">
  <!-- <span class="el-dropdown-link">
    下拉菜单<i class="el-icon-arrow-down el-icon--right"></i>
  </span> -->
  <el-dropdown-menu slot="dropdown">
    <el-dropdown-item command="space" ><div class="list"><img class="lisIcon" src="../../assets/my.png" ><span class="listName">我的</span> </div></el-dropdown-item>
    <el-dropdown-item command="logOut"><div class="list"><img class="lisIcon" src="../../assets/logOut.png" ><span class="listName">退出</span> </div></el-dropdown-item>
  </el-dropdown-menu>
</el-dropdown>

      </div>
    </div>
    <div class="line"></div>
      <router-view/>
  </div>
</template>

<script>
import icon from "../../assets/icon.png"
import Login from "../../components/Login.vue"

export default {
  name: 'App',
  components:{
    Login
  },
  data () {
    return {
      url:icon,
      size:0,
      dialogVisible: false,
      selectId:'',
      select:0,
    }
  },
  mounted:function() {
    console.log(this.$route.path);
    if(this.$route.path==="/Index"){
      this.select=0
    }else if(this.$route.path==="/Role"){
      this.select=2
    }else if(this.$route.path==="/Call"){
      this.select=3
    }else if(this.$route.path==="/Charpter"||this.$route.path==="/Part"){
      this.select=1
    }else{
      this.select=''
    }
  },
  methods:{
      choose(index){
          this.selectId=index
      },
      clear(){
          this.selectId=''
      },
      closeDialog(){
        this.dialogVisible=false
      },
    handleCommand(command){
      console.log(command);
      if(command==="logOut"){ 
        this.$store.commit('logOut')
        this.Cookies.set('cookie','',-1)
    if(this.$route.path==="/Space"){
      this.$router.push('../Index')
        this.dialogVisible=false
      this.select=0
    }
        // this.$router.push('../Index')
      // this.select=0
      }else{
        this.$router.push('../Space')
      this.select=''
      }

    },
    turnIndex(){
      this.select=0
      this.$router.push('../Index')
    },
    turnRole(){
      this.select=2
      this.$router.push('../Role')
    },
    turnCall(){
      this.select=3
      this.$router.push('../Call')
    },
    turnEinsim(){
      this.select=1
      this.$router.push('../Charpter')
    }
  }
}
</script>

<style scoped>
html{
    overflow-y:scroll
}
#app {
  font-family: -apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  /* color: #2c3e50; */
}
*{
  margin: auto;
  padding: 0;
}

.title{
  width: 100%;
  display: flex; 
  flex-wrap: wrap;
  justify-content: flex-start;
  /* width: 75vw; */
  /* height: 6.25vw; */
}

.image{
  /* display: inline-block; */
  margin-left: 10%;
  margin-right: 0;
  height: 6.25vw;

  width: 7.7%;
}

.icon{
  margin-top: 2.3vw;
  width: 7.7vw;
  height: 2vw;
  margin-left: 0;
}

.navbar{
  margin-left:0;
  display: flex;
  justify-content: flex-start;
  /* width: 27.5vw; */
  font-size: 20rem;
}
.tab{
  float: left;
  margin-left: 5vw;
  font-size: 20rem;
  color: #5C606A;
  cursor:pointer;
}

.select{
  float: left;
  margin-left: 5vw;
  font-size: 20rem;
  color: #3DBDFE;
  cursor:pointer;
}

.login{
  margin-right: 10%;
}

.head{
  padding: 0 1vw;
  width: 3.3vw;
  height: auto;
  border-radius: 50%;
  cursor: pointer;
}

.loginBtn{
  /* width: 4.6vw; */
  /* height: 1.875vw; */
  padding: 0 1vw;
  font-size: 18rem;
  /* line-height: 1.875vw; */
  background-color: #fff;
  border-radius: 0.3vw;
  border:0.1vw solid #000 ;
  cursor:pointer;
}
.dialog{
  margin-top: 7vw;
  /* width: 44.8vw;
  height: 24vw; */
}

.dialogTitle{
  font-size: 26rem;
}
.choice{
  width: 80%;
  display: flex;
  justify-content:space-between
}

.choiceImg{
  width: 20%;
  cursor:not-allowed;
  margin-top: 3vw;
}

.weChat{
  cursor:pointer
}

.allow{
  font-size: 20rem;
  margin-top: 2vw;
}

.mask{
  height: 11.7vw;
  width: 11.7vw;
  background-color:  #fff;
}

.bgc{
  width: 100%;
  height: 100%;
  background-color:rgba(0,0,0,0.5) ;
  cursor: pointer;
}


.tip{
  margin-top: 20%;
  width: 40%;
  height: auto;
}

.line{
  width: 100%;
  height: 0.3vw;
  background: linear-gradient(90deg, #741682, #9937A8, #240433);
}

.fade-leave-to{
  display: none;
}

a{
  text-decoration: none;
  cursor: pointer;
  color: #000;
}

.el-dropdown-menu{
  width: 7vw;
  text-align: center;
}

.list{
  display: flex;
  justify-content: space-between;
}

.listIcon{
  margin-left: 0;
  margin-right: 0;
}

.listName{
  margin-left: 0;
  margin-right: 2vw;
}

</style>



// WEBPACK FOOTER //
// src/view/index/index.vue